import { useEffect, useState } from 'react';

import useGetPlannedMaintenance from '@/hooks/api/planned-maintenance/useGetPlannedMaintenance';

export default function useMaintenanceBar() {
  const [isClosed, setIsClosed] = useState<boolean>(true);
  const { data, isPending } = useGetPlannedMaintenance();

  useEffect(() => {
    if (data) {
      const maintenanceBarId = localStorage.getItem('maintenance-bar');
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setIsClosed(maintenanceBarId === data?.id);
    }
  }, [data]);

  function onClose() {
    setIsClosed(true);

    if (data) {
      localStorage.setItem('maintenance-bar', data?.id);
    }
  }

  return {
    data, isPending,
    isClosed,
    onClose,
  };
}
